import TheHelper from './TheHelper.vue'
import {ref, computed} from 'vue'
export default {
  install: (app, options) => {
    // memorizza l'helper attivo
    const activeElement = ref('')
    // se true mostra la sidebar dell'helper
    const isShow = ref(false)
    // memorizza l'elemento DOM di helper attivo
    const domElActive = ref(null);
    // se true indica che la pagina possiede un helper correttamente configurato
    const haveHelper = ref(false)

    const updateHaveHelper = (status) => haveHelper.value = status;

    // classe da applicare al container che racchiude tutti gli helper
    const helperContainerClass = '.js-helper-container';

    /**
     * Aggiorna status dell'helper attivo, viene passato via provide/inject al componente TheHelper.vue
     * @param status
     */
    function updateShow(status) {
      isShow.value = status;
      if(!status) resetAll();
    }

    /**
     * Resetta stili dell'icona di helper
     * @param helperEl
     * @private
     */
    function _resetStyle(helperEl) {
      // riporta lo sfondo che contiene icona e scritta in lettura a bianco
      helperEl.style.backgroundColor = '#fff';
      // riporta icona al colore primary
      helperEl.querySelector('svg').style.stroke = '#0069B4';
      // nasconde la scritta in lettura
      helperEl.querySelector('.js-helper-svg').style.display = 'none';
    }

    /**
     * Setta lo stile degli elementi passati come attivo
     * @param helperEl
     * @param helperInLetturaEl
     * @private
     */
    function _activeStyle(helperEl, helperInLetturaEl) {
      helperEl.style.backgroundColor = '#0069B4';
      helperEl.querySelector('svg').style.stroke = '#fff';
      helperInLetturaEl.style.display = 'block';
    }

    /**
     * Resetta tutte le helper icon contenuto nel container
     */
    function resetAll() {
      let helperSpan = document.querySelectorAll(helperContainerClass);
      Object.keys(helperSpan).forEach((spanKey) => _resetStyle(helperSpan[spanKey]))
    }

    /**
     * Aggiorna elemento helper attivo
     * @param status
     * @param activeKey
     */
    function updateHelperActived(status, activeKey) {
      activeElement.value = status;
      resetAll();
      let helperSpanActive = document.querySelector('[data-id='+activeKey+']');
      if(helperSpanActive) {
        helperSpanActive.style.textTransform = 'initial';
        helperSpanActive.style.fontWeight = 'normal';
        helperSpanActive.style.fontSize = '12px';
        helperSpanActive.style.lineHeight = '18px';
        let helperSpanActiveContainer = helperSpanActive.closest(helperContainerClass);
        _activeStyle(helperSpanActiveContainer, helperSpanActive)
        setTimeout(() => {
          // timeout per scroll del contenuto, posiziona l'elemento attivo visibile
          helperSpanActiveContainer.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
        }, 100);
      }
    }

    // dichiarazione del componente helper da poter usare nel progetto
    app.component('the-helper', TheHelper)

    // Json dei messaggi di helper passato al plugin vue in fase di inizializzazione dell'istanza
    app.provide('helperList', options)
    // dichiarazione di metodi/proprietà utilizzabili dal componente TheHelper
    app.provide('updateShow', updateShow)
    app.provide('helperActived', computed(() => activeElement.value))
    app.provide('showHelperSidebar',  computed(() => isShow.value))
    app.provide('updateHelperActived',  updateHelperActived)
    app.provide('domElActive',  computed(() => domElActive.value))
    app.provide('haveHelper',  computed(() => haveHelper.value))
    app.provide('updateHaveHelper',  updateHaveHelper)

    /**
     * Crea Icona di Helper e li aggancia l'evento click
     * @param binding
     * @param element
     * @return {HTMLSpanElement}
     * @private
     */
    function _createHelperElement(binding, element) {
      const el = document.createElement('span');
      const svgIcon = '<svg xmlns="http://www.w3.org/2000/svg" stroke="#0069B4" fill="none" viewBox="0 0 14 14" height="14" width="14"><g><circle cx="7" cy="7" r="6.5"  stroke-linecap="round" stroke-linejoin="round"></circle><path  d="M5.5,5.5A1.5,1.5,0,1,1,7,7V8"  stroke-linecap="round" stroke-linejoin="round"></path><path d="M7,9.5a.75.75,0,1,0,.75.75A.76.76,0,0,0,7,9.5Z" fill="#000000"></path></g></svg>';
      el.classList.add(binding.modifiers && binding.modifiers.relative ? 'crm:relative' : 'crm:absolute', 'crm:ml-[5px]', 'crm:cursor-pointer', 'crm:z-[35]',)
      el.innerHTML = `<span class="crm:flex crm:items-center js-helper-container crm:pr-2 crm:pl-1 crm:rounded-md"> ${svgIcon} <span class="js-helper-svg" data-id="${binding.value}" style="display:none; color: #fff; font-size: 12px; margin-left: 4px;">In lettura</span></span>`
      el.style.textTransform = 'initial';
      el.style.fontWeight = 'normal';
      el.style.fontSize = '12px';
      el.style.lineHeight = '18px';
      el.addEventListener('click', () => {
        activeElement.value = binding.value
        domElActive.value = element
        setTimeout(() => {
          // timeout per scroll del contenuto, posiziona l'elemento attivo visibile
          const targetElm = document.getElementById(activeElement.value);
          targetElm.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
        }, 100);
        // resetta tutti gli helper icon presenti in pagina
        resetAll();
        if(binding.value) _activeStyle(el.querySelector('.js-helper-container'), el.querySelector('.js-helper-svg'))
      })

      return el;
    }

    // Dichiara la direttiva custom da applicare al div dove si vuole mostrare l'icona di helper (es. v-fallcohelper)
    app.directive('fallcohelper', {
      beforeMount: function (element, binding, vnode) {
        element.appendChild(_createHelperElement(binding, element))
      },
      unmounted: function (element) {}
    })
  },
}